import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import People from './Components/People.component'
import Clients from './Components/Clients'
import ContactForm from '../commons/ContactForm/ContactForm.component'
import { translate } from 'react-translate'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'
import { OurTeam } from './Components/OurTeam/OurTeam.comopnent'
import { VisionWidget } from './Components/VisionWidget/VisionWidget.component'
import './PageCompany.scss'

@translate('Empresa')
class Empresa extends Component {

  componentDidMount() {
    window.location.hash = window.decodeURIComponent(window.location.hash)
    const scrollToAnchor = () => {
      const hashParts = window.location.hash.split('#')
      if (hashParts.length === 2) {
        const hash = hashParts.slice(-1)[0]
        try {
          document.querySelector(`#${hash}`).scrollIntoView()
        } catch(err) {
          // eslint-disable-next-line no-console
          console.error(err)
        }
      }
    }
    scrollToAnchor()
    window.onhashchange = scrollToAnchor
    this.props.loadDirectors()
    this.props.loadClients()
    this.props.loadBrokers()
  }

  render () {
    const { directors, clients, t, sectors, brokers } = this.props

    const visionData = [
      { title: t('Mision'), img: '/assets/images/handshake.png', text: t('Mision_texto') },
      { title: t('Vision'), img: '/assets/images/handshake.png', text: t('Vision_texto') },
      { title: t('Valores'), img: '/assets/images/handshake.png', text: t('Valores_texto') }
    ]

    const items = [
      { type: 'text', title: t('Nombre') },
      { type: 'text', title: t('Telefono') },
      { type: 'textarea', title: t('Consulta') }
    ]

    let director = selectDirector()

    function selectDirector () {
      if (directors){
        var arrayDirectors = directors.filter(function (d) {
          return d.signature !== undefined
        })
        return arrayDirectors
      }
    }

    const directorsView = (director) ? (
      <div className='intro-images'>
        {director.map((item, index) =>
          <div className='col-md-6 removePadding' key={index}>
            <People {...item} />
          </div>
        )}
      </div> )
    : ''

    const mainText = <div className='intro-info'>
      <p>{t('Empresa_Texto_Parrafo_1')}</p>
      <p>{t('Empresa_Texto_Parrafo_2')}</p>
      <p>{t('Empresa_Texto_Parrafo_3')}</p>
    </div>

    return (
      <div id='directors' name='directors' className='container-fluid'>
        <MainBanner
          backgroundURL={'/assets/images/home-search.jpg'}
          mainTitle={t('main_title')}
          className='main-banner-company'
        />
        <div className='intro-container hidden-xs'>
          <Row className='intro-content intro-wrapper'>
            <Col sm={4} md={4} lg={4}>
              <div className='first-column'>
                <h1>{t('Nuestra_Empresa')}</h1>
                {directorsView}
              </div>
            </Col>
            <Col sm={7} md={7} lg={7}>
              {mainText}
            </Col>
          </Row>
        </div>
        <div className='intro-container visible-xs'>
          <h1>{t('Nuestra_Empresa')}</h1>
          <div className='intro-wrapper'>
            <Col md={12} sm={12}>
              {mainText}
            </Col>
            <Col md={12} sm={12}>
              {directorsView}
            </Col>
          </div>
        </div>
        <VisionWidget data={visionData} />
        <OurTeam
          brokers={brokers}
          directors={directors}
          sectors={sectors}
        />
        { (clients) ? (
          <div id='clients' name='clients' className='clients-container'>
            <Clients clients={clients}/>
          </div>)
        : '' }
        <div className='form-container'>
          <ContactForm hideButtonBranches={true}/>
        </div>
      </div>
    )
  }
}

export default Empresa



// WEBPACK FOOTER //
// ./src/features/PageCompany/PageCompany.component.js